import { InputGroup, InputLeftElement } from '@chakra-ui/react';
import IconSearch from 'assets/icons/icon-search.svg?react';
import DebouncedInput from './DebouncedInput';

interface SearchInputProps {
  placeholder: string;
  value?: string | number;
  onChange: (value: string | number) => void;
}

export default function SearchInput({ placeholder, value, onChange }: SearchInputProps) {
  return (
    <InputGroup size="sm">
      <InputLeftElement pointerEvents="none">
        <IconSearch />
      </InputLeftElement>
      <DebouncedInput 
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        pl="30px"
      />
    </InputGroup>
  )
}
